import React from 'react';
import { motion } from 'framer-motion';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const AIWorkflowSection = ({ content }) => (
  <section id="ai-workflow" className="section section-light">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <div className="about-grid">
        {content.cards.map((card, index) => (
          <motion.div
            key={card.title}
            className="content-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.55, delay: index * 0.1 }}
          >
            <h3>{card.title}</h3>
            {card.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </motion.div>
        ))}
      </div>

      <motion.div
        className="ai-tools-card"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        transition={{ duration: 0.55, delay: 0.15 }}
      >
        <span className="card-label">{content.toolsLabel}</span>
        <div className="tag-list">
          {content.tools.map((tool) => (
            <span key={tool} className="tag">
              {tool}
            </span>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default AIWorkflowSection;
